import type { MinigameDefinition } from '@core/types';
import { MemoryConfig } from '@modules/memory/config';
import { MemoryScene } from '@modules/memory/MemoryScene';

/** Definicion publica del modulo de memoria para registrarlo en el catalogo. */
export const memoryMinigame: MinigameDefinition = {
  key: MemoryConfig.key,
  title: MemoryConfig.title,
  description: MemoryConfig.description,
  icon: MemoryConfig.icon,
  color: MemoryConfig.color,
  scene: MemoryScene,
};
